import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function isCurrentUserAuthed(currentUser, adminRoute) {
	if (currentUser) {
		if (adminRoute) {
			return currentUser.role === 'admin';
		} else {
			return true;
		}
	} 
	return false;
}

export const PrivateRoute = ({ component: Component, render: originalRender, currentUser, userLoading, adminRoute = false, ...rest }) => (
  <Route {...rest} render = {
    (props) => {
      if (!currentUser && localStorage.getItem('auth_token')) {
  			return (<div>Loading...</div>);
  		} else {
        if (Component) {
          return isCurrentUserAuthed(currentUser, adminRoute) ? <Component {...props} /> : <Redirect to='/host/signin' />
        } else {
          return isCurrentUserAuthed(currentUser, adminRoute) ? originalRender(props) : <Redirect to='/host/signin' />
        }
  		}
  	}
  } />
)

export default PrivateRoute